import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../common/constants/global.constant';
import { CommonService } from '../../common/services/common.service';
import { CreateProfileService } from '../../core/routing/services/profile/create-profile.service';
import {
  LogoContent,
  StoreLogo,
  PromotionalContent,
  Segment,
  BannerCarousel,
  ProfileRequest,
  PriceContent, FactTags, ProfileUpdateResponse, HeroTile
} from '../create-profile/interface/profile.i';
import { first } from 'rxjs/internal/operators/first';
import { ActivatedRoute } from '@angular/router';
import { ProfileStoreService } from '../../modules/create-profile/store/profile.store';
import { DeviceWallpaper } from '../asset-library/logo-content/interfaces/device-wallpaper';

@Component({
  selector: 'iposcen-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.scss']
})
export class CreateProfileComponent implements OnInit, OnDestroy {
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailerId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  isTabEnabled: boolean;
  sideNav: string;
  isTabVisited: boolean;
  isStoreLogoTabVisited: boolean;
  isPromoTabVisited: boolean;
  isBannerTabVisited: boolean;
  isSegmentTabVisited: boolean;
  isPriceTabVisited: boolean;
  isHeroTileTabVisited: boolean;
  isSettingsVisited: boolean;
  isFactTagsVisited: boolean;
  isSrtEnabled: boolean;
  isCustomTileEnabled: boolean;
  inActive: string;
  profileID: string;
  promo: string = GlobalConstants.PROMO;
  storelogo: string = GlobalConstants.STORE_LOGO;
  banner: string = GlobalConstants.BANNER;
  price: string = GlobalConstants.PRICE;
  bannerCId: string;
  profileData: string;
  segments: string = GlobalConstants.SEGMENTS;
  bannerCarousel: string = GlobalConstants.BANNER_CAROUSEL;
  factTag: string = GlobalConstants.FACT;
  setting: string = GlobalConstants.SETTINGS;
  heroTile: string = GlobalConstants.HERO_TILE;
  retailHQUser: string = GlobalConstants.RETAIL_HQ_USER;
  storeUser: string = GlobalConstants.STORE_USER;
  regionalUser: string = GlobalConstants.REGIONALHQ;
  installationPackage: string = GlobalConstants.INSTALLATION_PACKAGE;
  profileIdToEdit: string;
  storeLogoLabel = GlobalConstants.STORE_LOGO_LABEL;
  isChromebookSelected: boolean = false;
  heroTabActive = 'srtHeroTiles';
  isPriceSupress: boolean;
  isSrtUser = false;
  private ngUnsubscribe = new Subject<boolean>();
  iposLiteEnabled: boolean;

  constructor(
    private cmnService: CommonService,
    private createProfileService: CreateProfileService,
    private profileStoreService: ProfileStoreService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.cmnService.getHerotab
      .subscribe(res => {
        if (!res || res === GlobalConstants.SRT_CONTENT) {
          this.heroTabActive = 'srtHeroTiles';
        } else {
          this.heroTabActive = 'customHeroTiles';
        }
      })
    if (this.userRole === this.retailHQUser || this.userRole === this.storeUser || this.userRole === this.regionalUser) {
      this.createProfileService.getUserRoleData(this.userId, this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.isSrtEnabled = data.retailer.srtEnabled;
          this.cmnService.setSrtTileEnabled(this.isSrtEnabled);
          const retailerConfig = JSON.parse(data.retailer.configurations);
          this.isCustomTileEnabled = retailerConfig?.customSrtEnabled ? retailerConfig?.customSrtEnabled : false;
          this.cmnService.setCustomTileEnabled(this.isCustomTileEnabled);
          this.cmnService.isSizeContraintsEnabled = retailerConfig?.removeEnabled ? retailerConfig?.removeEnabled : false;
          this.isPriceSupress = retailerConfig?.isPriceSupress ? retailerConfig?.isPriceSupress : false;
          this.iposLiteEnabled = retailerConfig?.isIposChinaEnabled ? retailerConfig?.isIposChinaEnabled : false;
        });
    }
    if (this.userRole === GlobalConstants.SRT_ADMIN) {
      this.isSrtUser = true;
    }
    this.isTabEnabled = false;
    this.isTabVisited = false;
    this.isStoreLogoTabVisited = false;
    this.isPromoTabVisited = false;
    this.isBannerTabVisited = false;
    this.isPriceTabVisited = false;
    this.isHeroTileTabVisited = false;
    this.sideNav = GlobalConstants.PROFILE_INFO;
    this.profileID = '';
    this.inActive = '';
    // Observer to receive data from different pages
    this.cmnService.emitDataToProfileObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resp => {
        // Using the below method. Bcz In edit flow sometimes profileID is missing in PATCH API.
        this.profileID = this.createProfileService.getProfileId();
        if (resp.page === GlobalConstants.LOGO_CONTENT_GROUP) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            if (!resp.dwpEnabled) {
              this.sideNav = GlobalConstants.PROMO;
            } 
            this.isStoreLogoTabVisited = true;
            this.inActive = '';
          } else {
            const logoData: LogoContent = resp.dataSet as LogoContent;
            this.createProfileService.updateProfile(this.profileID, { logoContents: logoData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                // set the tab to promo on success            
                this.isStoreLogoTabVisited = true;
                this.inActive = '';
                if (!resp.isDWPEnabled && resp.dataSet == GlobalConstants.SKIP_DWP) {
                  this.sideNav = GlobalConstants.PROMO;
                }
                const updateProfileStoreLogo = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(updateProfileStoreLogo);
              });
          }
        } else if (resp.page === GlobalConstants.PROMO_CONTENT_GROUP) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            this.sideNav = GlobalConstants.SEGMENTS;
            this.isPromoTabVisited = true;
            this.inActive = '';
          } else {
            const promoContentData: PromotionalContent = resp.dataSet as PromotionalContent;
            this.createProfileService.updateProfile(this.profileID, { promotionalContents: promoContentData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
                // set the tab to segment on success
                this.sideNav = GlobalConstants.SEGMENTS;
                this.isPromoTabVisited = true;
                this.inActive = '';
              });
          }
        } else if (resp.page === GlobalConstants.STORE_PAGE) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            if (this.iposLiteEnabled) {
              this.sideNav = GlobalConstants.SETTINGS;
              this.isStoreLogoTabVisited = true;
            } else {
              if (resp.type === GlobalConstants.DEVICE_WALLPAPER) {
                this.sideNav = GlobalConstants.STORE_LOGO;
                this.isStoreLogoTabVisited = false;
              } else {
                this.sideNav = GlobalConstants.PROMO;
                this.isStoreLogoTabVisited = true;
              }
            }
            this.inActive = '';
          } else {            
            const storeLogosData: StoreLogo = resp.dataSet as StoreLogo;
            this.createProfileService.updateProfile(this.profileID, { storeLogos: storeLogosData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const updateProfileStoreLogo = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(updateProfileStoreLogo);
                if (this.iposLiteEnabled) {
                  this.sideNav = GlobalConstants.SETTINGS;
                  this.isStoreLogoTabVisited = true;
                }
              });
          }
        } else if (resp.page === GlobalConstants.SEGMENTS) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            this.isSegmentTabVisited = true;
            this.inActive = '';
            if (this.isChromebookSelected) {
              if (!this.isPriceSupress) {
                this.sideNav = GlobalConstants.PRICE;
              } else {
                this.sideNav = this.setSideNavForPrice();
              }
            } else {
              this.sideNav = GlobalConstants.BANNER;
            }
          } else {
            const segmentsData: Segment = resp.dataSet as Segment;
            this.createProfileService.updateProfile(this.profileID, { segments: segmentsData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
                this.isSegmentTabVisited = true;
                this.inActive = '';
                if (this.isChromebookSelected) {
                  if (!this.isPriceSupress) {
                    this.sideNav = GlobalConstants.PRICE;
                  } else {
                    this.sideNav = this.setSideNavForPrice();
                  }
                } else {
                  this.sideNav = GlobalConstants.BANNER;
                }
              });
          }
        } else if (resp.page === GlobalConstants.BANNER_CONTENT_GROUP) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            if (!this.isPriceSupress) {
              this.sideNav = GlobalConstants.PRICE;
            } else {
              this.sideNav = this.setSideNavForPrice();
            }
            this.isBannerTabVisited = true;
            this.inActive = '';
          } else {
            const bannerContentData: BannerCarousel = resp.dataSet as BannerCarousel;
            this.createProfileService.updateProfile(this.profileID, { bannerCarousels: bannerContentData })
              .subscribe(data => {
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
                if (!this.isPriceSupress) {
                  this.sideNav = GlobalConstants.PRICE;
                } else {
                  this.sideNav = this.setSideNavForPrice();
                }
                this.isBannerTabVisited = true;
                this.inActive = '';
              });
          }
        } else if (resp.page === GlobalConstants.PRICE_CONTENT_GROUP) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            this.sideNav = this.setSideNavForPrice();
            this.isPriceTabVisited = true;
            this.inActive = '';
          } else {
            const priceContentData: PriceContent = resp.dataSet as PriceContent;
            this.createProfileService.updateProfile(this.profileID, { priceContents: priceContentData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                this.sideNav = this.setSideNavForPrice();
                this.isPriceTabVisited = true;
                this.inActive = '';
                const updateProfileStoreLogo = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(updateProfileStoreLogo);
              });
          }
        } else if (resp.page === GlobalConstants.HERO_TILE) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            if (this.isChromebookSelected) {
              this.sideNav = GlobalConstants.SETTINGS;
            } else {
              if (!(this.heroTabActive === 'customHeroTiles' && this.isSrtEnabled)) {
                this.sideNav = GlobalConstants.FACT;
              } else {
                this.cmnService.setToSrtTab(true);
              }
            }
            this.isHeroTileTabVisited = true;
            this.inActive = '';
          } else {
            const heroTileData: HeroTile = resp.dataSet as HeroTile;
            this.createProfileService.updateProfile(this.profileID, { [this.heroTabActive]: heroTileData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                this.isHeroTileTabVisited = true;
                if (this.isChromebookSelected) {
                  this.sideNav = GlobalConstants.SETTINGS;
                } else {
                  if (!(this.heroTabActive === 'customHeroTiles' && this.isSrtEnabled)) {
                    this.sideNav = GlobalConstants.FACT;
                  } else {
                    this.cmnService.setToSrtTab(true);
                  }
                }
                this.inActive = '';
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
              });
          }
        } else if (resp.page === GlobalConstants.FACT_TAG) {
          if (resp.dataSet === GlobalConstants.SKIP) {
            this.sideNav = GlobalConstants.SETTINGS;
            this.isFactTagsVisited = true;
            this.inActive = '';
          } else {
            this.createProfileService.updateProfile(this.profileID, { factTags: resp.dataSet })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                // set the tab to segment on success
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
                this.sideNav = GlobalConstants.SETTINGS;
                this.isFactTagsVisited = true;
                this.inActive = '';
              });
          }
        } else if (resp.page === GlobalConstants.INSTALLATION_PACKAGE) {
          if (resp.dataSet === GlobalConstants.SKIP) {
            this.sideNav = GlobalConstants.INSTALLATION_PACKAGE;
            this.isFactTagsVisited = true;
            this.inActive = '';
          } else {
            this.createProfileService.updateProfile(this.profileID, { factTags: resp.dataSet })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                // set the tab to segment on success
                this.sideNav = GlobalConstants.INSTALLATION_PACKAGE;
                this.isFactTagsVisited = true;
                this.inActive = '';
              });
          }
        } else if (resp.page === GlobalConstants.SETTINGS) {
          if (resp.dataSet === GlobalConstants.SKIP) {
            this.sideNav = GlobalConstants.INSTALLATION_PACKAGE;
            this.isSettingsVisited = true;
            this.inActive = '';
          } else {
            this.createProfileService.updateProfile(this.profileID, { settings: JSON.stringify(resp.dataSet) })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const updateProfileStoreLogo = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(updateProfileStoreLogo);
                // set the tab to segment on success
                this.sideNav = GlobalConstants.INSTALLATION_PACKAGE;
                this.isSettingsVisited = true;
                this.inActive = '';
              });
          }
        } else if (resp.page === GlobalConstants.DEVICE_WALLPAPER) {
          if (typeof resp.dataSet === GlobalConstants.STRING) {
            this.sideNav = GlobalConstants.PROMO;
            this.isStoreLogoTabVisited = true;
            this.inActive = '';
          } else {            
            const deviceWallpapersData: DeviceWallpaper = resp.dataSet as DeviceWallpaper;
            this.createProfileService.updateProfile(this.profileID, { deviceWallpaper: deviceWallpapersData })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const updateProfiledeviceWallpaper = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(updateProfiledeviceWallpaper);
              });
          }
        }

      });

    this.cmnService.bannerContentIdObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.bannerCId = res;
        this.profileData = this.createProfileService.getProfileId();
        const banneContentInfo: BannerCarousel = {
          bannerCarouselId: this.bannerCId,
          showOnDevice: true
        };
        const profileRequest: ProfileRequest = {
          bannerCarousels: [banneContentInfo]
        };

        this.createProfileService.updateLogoContentId(this.profileData, JSON.stringify(profileRequest))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(response => {
            // TODO
          },
            error => {
            });
      });

    this.activatedRoute.params.subscribe(params => {
      this.profileIdToEdit = params[GlobalConstants.PROFILE_ID];
    });

    this.createProfileService.emitInstallationPackage.subscribe(info => {
      if (info) {
        this.inActive = GlobalConstants.IN_ACTIVE;
        this.sideNav = GlobalConstants.INSTALLATION_PACKAGE;
      }
    });
    if (!this.profileIdToEdit) {
      this.inActive = GlobalConstants.IN_ACTIVE;
    }
    //To subscribe when chromebook selection emit happens from child components. - II 3289
    this.cmnService.chromebookObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.isChromebookSelected = res;
      });
    if (this.profileIdToEdit) {
      this.createProfileService.getProfileDetailsById(this.profileIdToEdit)
        .subscribe(profileData => {
          this.iposLiteEnabled = JSON.parse(profileData.profile.settings).otherSettings.enableProfileIposlite;
        });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setSideNav(value: string) {
    this.profileIdToEdit = this.createProfileService.getProfileId();
    this.sideNav = value;
    // IIT2-9196 -start
    if (this.sideNav === GlobalConstants.BANNER) this.cmnService.isBannerCarousel = true;
    else this.cmnService.isBannerCarousel = false;
    // IIT2-9196 -end
    window.scroll(0, 0);
  }

  setCreateProfileView(data) {
    if (this.profileIdToEdit) {
      this.profileID = this.profileIdToEdit;
    } else if (data.responseContext.success) {
      this.profileID = data.profile.profileId;
    }
    if (this.userRole === GlobalConstants.SRT_ADMIN) {
      this.sideNav = GlobalConstants.INSTALLATION_PACKAGE;
    } else {
      this.sideNav = GlobalConstants.STORE_LOGO;
    }
    this.isTabVisited = true;
    this.inActive = '';
  }

  setSideNavForPrice() {
    if (this.isChromebookSelected) {
      return GlobalConstants.SETTINGS;
    } else if (this.isSrtEnabled || this.isCustomTileEnabled) {
      return GlobalConstants.HERO_TILE;
    }
    else {
      return GlobalConstants.FACT;
    }
  }

  setIposLitePRC(data) {
    this.iposLiteEnabled = data;
  }
}
